import { useEffect, useRef } from "react"

const PRERENDER_READY_EVENT = "appshell:prerender-ready"

const usePrerenderSignal = (isDataReady: boolean) => {
  const hasSignaledRef = useRef(false)

  useEffect(() => {
    if (isDataReady && !hasSignaledRef.current) {
      hasSignaledRef.current = true
      window.dispatchEvent(new CustomEvent(PRERENDER_READY_EVENT))
    }
  }, [isDataReady])
}

export default usePrerenderSignal
